import React, { useState, useRef, useEffect } from "react";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import { Transaction_Profile } from "../../Connections/Transaction";

import "../../Styles/Transfer.css";
import "../../Styles/Transferwallet.css";

import Toast from "../../Utils/Toast";

const Transfer = ({ close, walletBalance }) => {
    const [moneyvalue, setMoneyvalue] = useState();
    const [phoneNumbervalue, setPhoneNumbervalue] = useState();
    const [showTransfer, setShowTransfer] = useState(false);
    const [showTransferNext, setShowTransferNext] = useState(false);
    const [bill, setBill] = useState({});

    const [loading, setLoading] = useState(false);

    //===========================================================

    const wrapper_ref = useRef(null);

    //===========================================================

    const handleSubmitTransferForm = (e) => {
        e.preventDefault();
        if (moneyvalue <= walletBalance) {
            setLoading(true);
            Transaction_Profile.TransferWallet({
                mobile: phoneNumbervalue,
                price: moneyvalue,
            })
                .then((res) => {
                    if (res[0]) {
                        Toast("success", "انتقال با موفقیت انجام شد!");
                        setBill(res[2].data);
                        setShowTransfer(true);
                        setPhoneNumbervalue("");
                        setMoneyvalue("");
                    } else {
                        Toast("error", res[1]);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                });
        } else {
            Toast("error", "موجودی کافی ندارید!");
        }
    };

    //===========================================================

    useEffect(() => {
        wrapper_ref.current.scrollTo(0, 0);
    }, [showTransfer]);

    //===========================================================

    return (
        <div className="wallet-wrapper">
            <div className="Transfer" ref={wrapper_ref}>
                {window.outerWidth > 768 ? (
                    showTransfer ? (
                        <div
                            className="Transferwallet-inside"
                            ref={wrapper_ref}
                        >
                            <div className="Transferwallet-inside-item1">
                                <div className="Transferwallet-inside-item1-text">
                                    <p className="Transferwallet-inside-item1-text-p">
                                        انتقال به کیف پول
                                    </p>
                                </div>

                                <div
                                    className="Transferwallet-inside-item1-image"
                                    onClick={close}
                                >
                                    <img
                                        className="Transferwallet-inside-item1-image-img"
                                        src="imgs/Profile/Icon.svg"
                                    />
                                </div>
                            </div>
                            <div className="Transferwallet-inside-item2">
                                <div className="Transferwallet-inside-item2-image1">
                                    <img
                                        className="Transferwallet-inside-item2-image1-img"
                                        src="imgs/Profile/Walletbag.svg"
                                    />
                                </div>

                                <div className="Transferwallet-inside-item2-image2">
                                    <img
                                        className="Transferwallet-inside-item2-image2-img"
                                        src="imgs/Profile/Felesh2.svg"
                                    />
                                </div>

                                <div className="Transferwallet-inside-item2-image3">
                                    <img
                                        className="Transferwallet-inside-item2-image3-img"
                                        src="imgs/Profile/Walletbag.svg"
                                    />
                                </div>
                            </div>
                            <div className="Transferwallet-inside-item3">
                                <div className="Transferwallet-inside-item3-inside">
                                    <div className="Transferwallet-inside-item3-inside-image">
                                        <img
                                            className="Transferwallet-inside-item3-inside-image-img"
                                            src="imgs/Profile/Tikgreen.svg"
                                        />
                                    </div>
                                    <p className="Transferwallet-inside-item3-inside-text">
                                        با موفقیت منتقل شد!
                                    </p>
                                </div>
                            </div>

                            <div className="Transferwallet-inside-item4">
                                <div className="History-inside-item3-bottom-item1">
                                    <div className="History-inside-item3-bottom-item1-right">
                                        <p className="History-inside-item3-bottom-item1-right-text">
                                            مبلغ تراکنش
                                        </p>
                                    </div>
                                    <div className="History-inside-item3-bottom-item1-left">
                                        <p className="History-inside-item3-bottom-item1-left-text">
                                            <span className="History-inside-item3-bottom-item1-left-Money number-font">
                                                {bill.price}
                                            </span>
                                            تومان
                                        </p>
                                    </div>
                                </div>

                                <div className="History-inside-item3-bottom-item2">
                                    <div className="History-inside-item3-bottom-item2-right">
                                        <p className="History-inside-item3-bottom-item2-right-text">
                                            تاریخ تراکنش
                                        </p>
                                    </div>
                                    <div className="History-inside-item3-bottom-item2-left">
                                        <p className="History-inside-item3-bottom-item2-left-time number-font">
                                            {new Date(
                                                bill.date?.split("T")[0]
                                            ).toLocaleDateString("fa", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                            })}
                                        </p>
                                    </div>
                                </div>

                                <div className="History-inside-item3-bottom-item3">
                                    <div className="History-inside-item3-bottom-item3-right">
                                        <p className="History-inside-item3-bottom-item3-right-text">
                                            کد رهگیری
                                        </p>
                                    </div>
                                    <div className="History-inside-item3-bottom-item3-left">
                                        <p className="History-inside-item3-bottom-item3-left-code number-font">
                                            {bill.refId}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="Transferwallet-inside-item5">
                                <button
                                    className="Transferwallet-inside-item5-button"
                                    onClick={close}
                                >
                                    برگشت به پروفایل
                                </button>
                            </div>
                        </div>
                    ) : (
                        <form
                            onSubmit={handleSubmitTransferForm}
                            className="Transfer-inside"
                        >
                            <div className="Transfer-inside-item1">
                                <div className="Transfer-inside-item1-text">
                                    <p className="Transfer-inside-item1-text-p">
                                        انتقال به کیف پول
                                    </p>
                                </div>

                                <div
                                    className="Transfer-inside-image"
                                    onClick={close}
                                >
                                    <img
                                        className="Transfer-inside-image-img"
                                        src="imgs/Profile/Icon.svg"
                                    />
                                </div>
                            </div>
                            <div className="Transfer-inside-item2">
                                <div className="Transfer-inside-item2-image1">
                                    <img
                                        className="Transfer-inside-item2-image1-img"
                                        src="imgs/Profile/Rechargewallet.svg"
                                    />
                                </div>
                            </div>
                            <div className="Transfer-inside-item3">
                                <div className="Transfer-inside-item3-inside">
                                    <div className="Transfer-inside-item3-inside-right">
                                        <p className="Transfer-inside-item3-inside-right-text">
                                            موجودی کیف پول شما
                                        </p>
                                    </div>
                                    <div className="Transfer-inside-item3-inside-left">
                                        <p className="Transfer-inside-item3-inside-left-text">
                                            <span className="Transfer-inside-item3-inside-left-Money number-font">
                                                {walletBalance}
                                            </span>
                                            تومان
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="Transfer-inside-item4">
                                <div className="Transfer-inside-item4-inside">
                                    <div className="Transfer-inside-item4-inside-top">
                                        <p className="Transfer-inside-item4-inside-top-text">
                                            شماره کیف پول مقصد رو وارد کن
                                        </p>
                                    </div>
                                    <div className="Transfer-inside-item4-inside-bottom">
                                        <input
                                            className="Transfer-inside-item4-inside-bottom-input"
                                            type="number"
                                            required
                                            id="phoneNumber"
                                            value={phoneNumbervalue}
                                            onInvalid={(e) => {e.preventDefault(); Toast("error", "لطفا شماره موبایل را وارد کنید.")}}
                                            onChange={(e) => {
                                                if (
                                                    e.target.value.length <= 11
                                                ) {
                                                    setPhoneNumbervalue(
                                                        e.target.value
                                                    );
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor="phoneNumber"
                                            className="Transfer-inside-item4-inside-bottom-label"
                                        >
                                            شماره تلفن
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="Transfer-inside-item5">
                                <div className="Transfer-inside-item4-inside">
                                    <div className="Transfer-inside-item4-inside-top">
                                        <p className="Transfer-inside-item4-inside-top-text">
                                            مبلغ دلخواه خودت رو وارد کن
                                        </p>
                                    </div>
                                    <div className="Transfer-inside-item4-inside-bottom">
                                        <input
                                            className="Transfer-inside-item4-inside-bottom-input input-Money"
                                            type="number"
                                            required
                                            id="money"
                                            value={moneyvalue}
                                            onInvalid={(e) => {e.preventDefault(); Toast("error", "لطفا مبلغ را وارد کنید.")}}
                                            onChange={(e) =>
                                                setMoneyvalue(e.target.value)
                                            }
                                        />
                                        <label
                                            htmlFor="money"
                                            className="Transfer-inside-item4-inside-bottom-label"
                                        >
                                            مبلغ دلخواه
                                        </label>
                                        <p className="Transfer-inside-item4-inside-bottom-text">
                                            تومان
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="Transfer-inside-item6">
                                <button
                                    className="Transfer-inside-item6-button"
                                    type="submit"
                                >
                                    {loading ? <LoadingSpinner /> : "انتقال"}
                                </button>
                            </div>
                        </form>
                    )
                ) : showTransferNext ? (
                    showTransfer ? (
                        <div
                            className="Transferwallet-inside"
                            ref={wrapper_ref}
                        >
                            <div className="Transferwallet-inside-item1">
                                <div className="Transferwallet-inside-item1-text">
                                    <p className="Transferwallet-inside-item1-text-p">
                                        انتقال به کیف پول
                                    </p>
                                </div>

                                <div
                                    className="Transferwallet-inside-item1-image"
                                    onClick={close}
                                >
                                    <img
                                        className="Transferwallet-inside-item1-image-img"
                                        src="imgs/Profile/Icon.svg"
                                    />
                                </div>
                            </div>
                            <div className="Transferwallet-inside-item2">
                                <div className="Transferwallet-inside-item2-image1">
                                    <img
                                        className="Transferwallet-inside-item2-image1-img"
                                        src="imgs/Profile/Walletbag.svg"
                                    />
                                </div>

                                <div className="Transferwallet-inside-item2-image2">
                                    <img
                                        className="Transferwallet-inside-item2-image2-img"
                                        src="imgs/Profile/Felesh2.svg"
                                    />
                                </div>

                                <div className="Transferwallet-inside-item2-image3">
                                    <img
                                        className="Transferwallet-inside-item2-image3-img"
                                        src="imgs/Profile/Walletbag.svg"
                                    />
                                </div>
                            </div>
                            <div className="Transferwallet-inside-item3">
                                <div className="Transferwallet-inside-item3-inside">
                                    <div className="Transferwallet-inside-item3-inside-image">
                                        <img
                                            className="Transferwallet-inside-item3-inside-image-img"
                                            src="imgs/Profile/Tikgreen.svg"
                                        />
                                    </div>
                                    <p className="Transferwallet-inside-item3-inside-text">
                                        با موفقیت منتقل شد!
                                    </p>
                                </div>
                            </div>

                            <div className="Transferwallet-inside-item4">
                                <div className="History-inside-item3-bottom-item1">
                                    <div className="History-inside-item3-bottom-item1-right">
                                        <p className="History-inside-item3-bottom-item1-right-text">
                                            مبلغ تراکنش
                                        </p>
                                    </div>
                                    <div className="History-inside-item3-bottom-item1-left">
                                        <p className="History-inside-item3-bottom-item1-left-text">
                                            <span className="History-inside-item3-bottom-item1-left-Money number-font">
                                                {bill.price}
                                            </span>
                                            تومان
                                        </p>
                                    </div>
                                </div>

                                <div className="History-inside-item3-bottom-item2">
                                    <div className="History-inside-item3-bottom-item2-right">
                                        <p className="History-inside-item3-bottom-item2-right-text">
                                            تاریخ تراکنش
                                        </p>
                                    </div>
                                    <div className="History-inside-item3-bottom-item2-left">
                                        <p className="History-inside-item3-bottom-item2-left-time number-font">
                                            {new Date(
                                                bill.date?.split("T")[0]
                                            ).toLocaleDateString("fa", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                            })}
                                        </p>
                                    </div>
                                </div>

                                <div className="History-inside-item3-bottom-item3">
                                    <div className="History-inside-item3-bottom-item3-right">
                                        <p className="History-inside-item3-bottom-item3-right-text">
                                            کد رهگیری
                                        </p>
                                    </div>
                                    <div className="History-inside-item3-bottom-item3-left">
                                        <p className="History-inside-item3-bottom-item3-left-code number-font">
                                            {bill.refId}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="Transferwallet-inside-item5">
                                <button
                                    className="Transferwallet-inside-item5-button"
                                    onClick={close}
                                >
                                    برگشت به پروفایل
                                </button>
                            </div>
                        </div>
                    ) : (
                        <form
                            onSubmit={handleSubmitTransferForm}
                            className="Transfer-inside"
                        >
                            <div className="Transfer-inside-item1">
                                <div className="Transfer-inside-item1-text">
                                    <p className="Transfer-inside-item1-text-p">
                                        انتقال به کیف پول
                                    </p>
                                </div>

                                <div
                                    className="Transfer-inside-image"
                                    onClick={close}
                                >
                                    <img
                                        className="Transfer-inside-image-img"
                                        src="imgs/Profile/Icon.svg"
                                    />
                                </div>
                            </div>

                            <div className="Transfer-inside-item2">
                                <div className="Transfer-inside-item2-image1">
                                    <img
                                        className="Transfer-inside-item2-image1-img"
                                        src="imgs/Profile/Rechargewallet.svg"
                                    />
                                </div>
                            </div>

                            <div className="Transfer-inside-item3">
                                <div className="Transfer-inside-item3-inside">
                                    <div className="Transfer-inside-item3-inside-right">
                                        <p className="Transfer-inside-item3-inside-right-text">
                                            موجودی کیف پول شما
                                        </p>
                                    </div>
                                    <div className="Transfer-inside-item3-inside-left">
                                        <p className="Transfer-inside-item3-inside-left-text">
                                            <span className="Transfer-inside-item3-inside-left-Money number-font">
                                                {walletBalance}
                                            </span>
                                            تومان
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="Transfer-inside-item5">
                                <div className="Transfer-inside-item4-inside">
                                    <div className="Transfer-inside-item4-inside-top">
                                        <p className="Transfer-inside-item4-inside-top-text">
                                            مبلغ دلخواه خودت رو وارد کن
                                        </p>
                                    </div>
                                    <div className="Transfer-inside-item4-inside-bottom">
                                        <input
                                            className="Transfer-inside-item4-inside-bottom-input input-Money"
                                            type="number"
                                            required
                                            id="money"
                                            value={moneyvalue|| ""}
                                            onChange={(e) => {
                                                setMoneyvalue(e.target.value);
                                            }}
                                        />
                                        <label
                                            htmlFor="money"
                                            className="Transfer-inside-item4-inside-bottom-label"
                                        >
                                            مبلغ دلخواه
                                        </label>
                                        <p className="Transfer-inside-item4-inside-bottom-text">
                                            تومان
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="Transfer-inside-item6">
                                <button
                                    className="Transfer-inside-item6-button"
                                    type="submit"
                                >
                                    انتقال
                                </button>
                            </div>
                        </form>
                    )
                ) : (
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            setShowTransferNext(!showTransferNext);
                        }}
                        className="Transfer-inside"
                    >
                        <div className="Transfer-inside-item1">
                            <div className="Transfer-inside-item1-text">
                                <p className="Transfer-inside-item1-text-p">
                                    انتقال به کیف پول
                                </p>
                            </div>

                            <div
                                className="Transfer-inside-image"
                                onClick={close}
                            >
                                <img
                                    className="Transfer-inside-image-img"
                                    src="imgs/Profile/Icon.svg"
                                />
                            </div>
                        </div>

                        <div className="Transfer-inside-item2">
                            <div className="Transfer-inside-item2-image1">
                                <img
                                    className="Transfer-inside-item2-image1-img"
                                    src="imgs/Profile/Rechargewallet.svg"
                                />
                            </div>
                        </div>

                        <div className="Transfer-inside-item3">
                            <div className="Transfer-inside-item3-inside">
                                <div className="Transfer-inside-item3-inside-right">
                                    <p className="Transfer-inside-item3-inside-right-text">
                                        موجودی کیف پول شما
                                    </p>
                                </div>
                                <div className="Transfer-inside-item3-inside-left">
                                    <p className="Transfer-inside-item3-inside-left-text">
                                        <span className="Transfer-inside-item3-inside-left-Money number-font">
                                            {walletBalance}
                                        </span>
                                        تومان
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="Transfer-inside-item4">
                            <div className="Transfer-inside-item4-inside">
                                <div className="Transfer-inside-item4-inside-top">
                                    <p className="Transfer-inside-item4-inside-top-text">
                                        شماره کیف پول مقصد رو وارد کن
                                    </p>
                                </div>
                                <div className="Transfer-inside-item4-inside-bottom">
                                    <input
                                        className="Transfer-inside-item4-inside-bottom-input"
                                        type="number"
                                        required
                                        id="phoneNumber"
                                        value={phoneNumbervalue}
                                        onChange={(e) =>
                                            setPhoneNumbervalue(e.target.value)
                                        }
                                    />
                                    <label
                                        htmlFor="phoneNumber"
                                        className="Transfer-inside-item4-inside-bottom-label"
                                    >
                                        شماره تلفن
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="Transfer-inside-item6">
                            <button
                                className="Transfer-inside-item6-button"
                                type="submit"
                            >
                                ادامه
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};
export default Transfer;
